import * as React from 'react';

import FinanceContract56 from './FinanceContract56';

export const financeContract56 = () => <FinanceContract56 />;

export default {
    title: 'Illustration/FinanceContract56',
    component: FinanceContract56,
    parameters: {
        notes: "`import FinanceContract56 from 'box-ui-elements/es/illustration/FinanceContract56';`",
    },
};
